export enum ViewScopeEnum {
  GLOBAL = "GLOBAL",
  COMPANY = "COMPANY",
  USER = "USER",
}
